module.exports = __webpack_public_path__ + "img/black-smooth-textured-paper-background.1235f50b.jpg";